// extracted by mini-css-extract-plugin
export var copyIcon = "_y6-2";
export var discountCard = "_y6-0";
export var discountCode = "_y6-3";
export var discountContent = "_y6-1";
export var loadingCard = "_y6-4";